
    import { ValidationProvider } from "vee-validate";
    import Vue from 'vue';

    export default Vue.extend({
        name: "TextInput",
        components: {
            ValidationProvider
        },
        props: {
            value: {
                type: String,
                default: ""
            },
            rules: {
                type: [String, Object],
                default: ""
            },
            placeholder: {
                type: String,
                default: ""
            },
            label: {
                type: String,
                default: ""
            },
            helpText: {
                type: String,
                default: ""
            },
            helpLabel: {
                type: String,
                default: ""
            },
            counter: {
                type: String,
                default: ""
            },
            rows: {
                type: String,
                default: "2"
            },
            name: {
                type: String,
                default: ""
            },
            vid: {
                type: String,
                default: undefined
            },
            type: {
                type: String,
                default: "text",
                validator(value:string) {
                    return [
                        "url",
                        "text",
                        "password",
                        "tel",
                        "search",
                        "number",
                        "email"
                    ].includes(value);
                }
            }
        },
        data () {
            return {
                currentValue: ""
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.currentValue = val;
                },
                //this makes it run the handler function on mount in addition to whenever the value changes
                immediate:true
            },
            currentValue(val) {
                // allows us to use v-model on our input.
                this.$emit("input", val);
            }
        }
    });
